import {NgModule} from "@angular/core";
import {TreatmentJourneyDefinitionModule} from "./definition/journey/treatmentJourneyDefinition.module";
import {TreatmentJourneyCommonModule} from "./common/journey/treatmentJourney.module";

@NgModule({
  imports: [
      TreatmentJourneyDefinitionModule,
      TreatmentJourneyCommonModule
  ]
})
export class TreatmentJourneyModule {

}